<template>
    <div>
    <div v-for="(data, index) in farmerQueries" :key="index">
        <div class="flex query-card">
            <!-- user details -->
            <div class="flex">
                <v-checkbox 
                    v-model="selectedQuery" 
                    hide-details 
                    class="checkbox"  
                    color="success" 
                    :value="data.post.id"
                />

                <img class="farmer-avatar " :src="data.user.image ? data.user.image.thumbnail : dummyAvatar" alt="" referrerpolicy="no-referrer"/>
                <div class="farmer-details">
                    <p class="farmer-name">{{data.user.name}}</p>
                    <p v-if="data.user.location_name" class="farmer-addr">{{data.user.location_name}}</p>
                    <p v-else></p>
                </div>

                <div class="farmer-query">
                    <p class="query-line">{{data.post.description}}</p>
                    <span v-if="data.post.published_at" class="comment-date">
                        <time-ago :datetime="data.post.published_at" long :refresh="60" />
                    </span>
                </div>
            </div>

            <div class="flex farmer-post">
                <!-- query preview image  -->
                <div v-if="data.post.media.length > 0">
                    <img 
                        v-if="data.post.media.length > 0"
                        class="queryimg_preview" 
                        :src = "data.post.media[0].media_type === 'farmstock_video' ? data.post.media[0].thumbnail_url : data.post.media[0].url"
                        alt="" 
                    />
                </div>
                <button @click="handleViewClick(data)" class="query-header-btn">
                    View post
                </button> 
                
                <!-- show the query in detail  -->
                <div v-if="currselectedid === data.post.id">
                    <view-post :postDialog="postDialog" :querydata="data" @close="postDialog=false"/>
                </div>                
            </div>
        </div> 
    </div>
    </div>
</template>


<script>
import viewpost from "./viewpost.vue";
import showcomments from "./showcomments.vue";
import { mapActions } from "vuex";
import { TimeAgo } from "vue2-timeago";
import moment from "moment";

export default {
    name: "queryCard",

    data() {
        return {
            checkbox: false,
            dialog: false,
            postDialog: false,
            dummyAvatar : require("../../../../assets/DummyAvatar.png"),
            querydata : {},
            currselectedid : "",
            selectedQuery : [],
        };
    },
    components: {
        "view-post": viewpost,
        "show-comment": showcomments,
        TimeAgo,
    },

    watch:{
        checkboxModel:function(){
            if(this.checkboxModel){
                this.selectedQuery = []
                this.addAllQueryasSelcted()
            } else {
                // if all queries are already selected then deselect on clicked again main chceckbox
                if(this.selectedQuery.length === this.farmerQueries.length)
                    this.selectedQuery = []
            }        
        },
        selectedQuery:function(){
            this.$store.dispatch('queryStore/addSelectedQuery', { stateid: this.selectedQuery}); 

            // if some queries are deselcted then change icon of main checkbox
            if(this.selectedQuery.length !== this.farmerQueries.length){
                this.$emit("checkclicked")
            }
        },
    },

	props: {
        checkboxModel: Boolean,   
        farmerQueries: Array,
	},

    methods: {
        ...mapActions(["queryStore", "addSelectedQuery", "toggledialog", "toggledreplyialog"]),

        addAllQueryasSelcted(){
            this.farmerQueries.map(item => {
                this.selectedQuery.push(item.post.id)
            })
        },

        showpost() {
            this.toggledialog();
        },
 
        convertDate(date){ 
            var newfomat = moment.utc(date).format("YYYY-MM-DD HH:mm:ss")
            console.log();
            return newfomat;
        },

        handleViewClick(data){
            this.currselectedid = data.post.id
            this.postDialog = true;
            this.querydata = data;
        }   
    },

    computed: {
        close() {
            this.postDialog = false;
        },
    },
};
</script>


<style lang="scss" scoped>
.query-card {
    background-color: #ffffff;
    box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
    border-radius: 3px;
    justify-content: space-between;
    padding: 15px 20px;
    margin-top: 8px;
}
.comment-date {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #445149;
    text-align: right;
    padding-right: 10px;

    font-family: "Roboto";
    font-style: normal;
}
.checkbox {
    margin: 0px;
}

.farmer-avatar {
    margin-left: 20px;
    width: 43px;
    height: 43px;
    border-radius: 3px;
}
.queryimg_preview{
    height: 45px;
    width: 195px;
    border-radius: 3px;
    object-fit: cover;
}

.farmer-details {
    margin-left: 20px;
    width: 180px;
}


.farmer-name {
    font-size: 0.87rem;
    font-weight: 400;
    color: #445149;
    margin-bottom: 0px;
}

.farmer-addr {
    font-size: 0.75rem;
    color: #727b76;
    margin-bottom: 0px;
}

.farmer-query {
    margin-left: 20px;
    width: 600px;
}
@media all and (max-width: 1700px) {
.farmer-query {
    width: 550px;
    margin-left: 25px;
}
    .farmer-details {
        margin-left: 20px;
        width: 130px;
    }    
}
@media all and (max-width: 1600px) {
.farmer-query {
    width: 500px;
    margin-left: 25px;
}
    .farmer-details {
        margin-left: 20px;
        width: 130px;
    }    
}
   
@media all and (max-width: 1520px) {
.farmer-query {
    width: 450px;
    margin-left: 5px;
}
    .farmer-details {
        margin-left: 20px;
        width: 130px;
    }    
}   

@media all and (max-width: 1440px) {
    .farmer-query {
         margin-left: 20px;
        width: 400px;
    }   
    .farmer-details {
        margin-left: 20px;
        width: 100px;
    } 
}

@media all and (max-width: 1400px) {
    .farmer-query {
        margin-left: 10px;
        width: 390px;
    }   
    .farmer-details {
        margin-left: 20px;
        width: 100px;
    } 
}


.query-line {
    font-size: 0.9rem;
    font-weight: 500;
    color: #5b5b5b;
    margin-bottom: 0px;
}

.query-time {
    font-size: 0.75rem;
    font-weight: 400;
    color: #727b76;
    margin-bottom: 0px;
}

.query-header-btn {
    background-color: #fbfdfc;
    color: #1d8d56;
    font-size: 0.9rem;
    padding: 10px 14px;
    border-radius: 3px;
    margin: 0px 20px;
    font-weight: 400;

    img {
        margin-bottom: 0.9px;
        margin-right: 5px;
    }
}
</style>

<!-- :close="postDialog=false"  -->